//import $ from 'jquery';
import Menu from  './menu-component';
var main_menu_container = null;
var top_menu = null;
var sub_menu = null;
var bread_crumb = null;
var mobile_bread_crumb = null;
const allCapsAlpha = [..."ABCDEFGHIJKLMNOPQRSTUVWXYZ"]; 
const allLowerAlpha = [..."abcdefghijklmnopqrstuvwxyz"]; 
const allNumbers = [..."0123456789"];
const base = [...allCapsAlpha, ...allNumbers, ...allLowerAlpha];
var submenu_list = [];
var menuClasses = [];
var isMobile = false;
var generator = (base, len) => {
  return [...Array(len)]
     .map(i => base[Math.random()*base.length|0])
     .join('');
};

$(document).ready(function() {
    main_menu_container = $(".main--navigation");
    top_menu = $(".main--navigation").find(".menu").first();
    var breadcrumb_string = "";
    
    if (!$(".main--navigation").find(".breadcrumb").length) {
        breadcrumb_string += "<div><nav role='navigation' class='breadcrumb' aria-labelledby='system-breadcrumb'><ol></ol></nav></div>";
        $(".block-slidemenunavigationcontainer").append(breadcrumb_string);
    }
    
    bread_crumb = $(".main--navigation").find(".breadcrumb").children('ol');
    
    if(window.matchMedia("(max-width: 767px)").matches){
        isMobile = true;
        bread_crumb.parent().append("<a href='#' class='mobile-breadcrumb hidden'> < </a>");
        mobile_bread_crumb = $(".mobile-breadcrumb");
    }
    
    sub_menu = top_menu.find(".menu").first();
    var source_left = 0;
    var source_top = 0;
    var source_width = 0;
    var top_menu_offset = 0;
    var home_id = 0;
    var top_level = main_menu_container.find(".menu--top-level");
    var homeText = "Home";

    if ($("#country_code").val() == "zh-cn")
    {
        homeText = "首页";
    } else if ($("#country_code").val() == "zh-tw")
    {
        homeText = "首頁";
    }
    
    var home_key_value = {
        'id': home_id,
        'text': homeText
    };
    submenu_list.push(home_key_value);
    findSubmenu(top_level);
    
    var menus = $(".main--navigation").find(".menu");
    $.each(menus, function(index) {
        menuClasses[$(this).attr('id')] = new Menu(document.getElementById($(this).attr('id')), $(this).attr('id'));
    });
    resetMenu();
    $(".menu-toggle").on('click', function() {
        
        if($(".main--navigation").hasClass("first-load")) {
          $(".main--navigation").removeClass("first-load");
        }
        $('.menu-toggle').toggleClass('open');
        $(".main--navigation").toggleClass("show").toggleClass('hide');
        if (main_menu_container.hasClass("sub-menu--loaded")) {
            main_menu_container.removeClass("sub-menu--loaded");
        }
        
        if (main_menu_container.hasClass("show")) {
            
            menuClasses[0].animate();
        }
        
        if (main_menu_container.hasClass("hide")) {
            setTimeout(function() {
                resetMenu();
            }, 500);
        }
        
        top_menu_offset = top_menu.offset();
        source_left = top_menu_offset.left;
        source_top = top_menu_offset.top;
        
  });
  
  $(".menu-item").on('click', function(e) {
        var parent_menu = null;
        // console.log(menuClasses);
        if ($(this).hasClass("menu-item--expanded")) {
            e.preventDefault();
            var source_element = $(this);
            var parent_id = $(this).data('id');
            var target = $("#" + parent_id);
            parent_menu = $(this).parents(".menu");
            submenu_list[parent_menu.data('level')] = {
                'id': source_element.data('id'),
                'text': source_element.children('a').html()
            }
            
            if (isMobile) {
                menuClasses[parent_menu.attr('id')].jq_element.fadeOut(300, function() {
                    menuClasses[parent_menu.attr('id')].resetMenuSettings();
                });
                
                menuClasses[parent_id].jq_element.addClass('first-column').removeClass('hidden');
                menuClasses[parent_id].animate();
                buildMobileBreadCrumb();
                return false;
            }
            
            
            if (!main_menu_container.hasClass("sub-menu--loaded")) {
                main_menu_container.toggleClass("sub-menu--loaded");    
            }
            
            target.removeClass("hidden");
            parent_menu.children('li').children('a').removeClass("active-link").addClass("blur-link");
            source_element.children('a').removeClass("blur-link").addClass('active-link');
            target.children('li').children('a').removeClass("blur-link");
            // Check if the menu is in the first column
            if (parent_menu.hasClass("first-column")) {
                // Check if the menu doesn't have a loaded second column
                if (!target.hasClass("second-column")) {
                    if ($(".second-column").length) {
                        
                        $(".second-column").fadeOut(500, function() {
                            $(this).removeClass("second-column").addClass("hidden").removeAttr('style');
                            $(this).children("li").removeClass("in-from-right").removeClass("out-to-right").css("opacity", 0);
                            
                        });
                    }
                    target.addClass("second-column");
                    var time_animation = menuClasses[parent_id].animate();
                }
            } 
            // Second column link click
            else {
                
                // var time_animation = animate($(".first-column"), "out-to-left");
                var prev_menu_id = $(".first-column").attr('id');
                var timeout_length = (menuClasses[prev_menu_id].menuItem().length * 100);

                menuClasses[prev_menu_id].jq_element.fadeOut(200, function() {
                    menuClasses[prev_menu_id].resetMenuSettings();
                });
                // animate("out-to-left", false);
                
                // Slides to the left the second column so that it will move to the first column
                setTimeout(function() {
                    menuClasses[parent_menu.attr('id')].jq_element.removeClass('second-column').addClass('first-column');    
                }, 200)
                
                slideSecondColumn(target);
            }
            buildBreadCrumb();
            return false;
        }
  });
});

// Menu class here

$(document).on('click', ".breadcrumb_link", function() {
    var target = $(this).data("target-id");
    var first_column_id = $(".first-column").attr("id");
    var second_column_id = $(".second-column").attr("id");
    var first_column_menu = $("[data-id=" + target + "]").parents(".menu");
    var second_column_menu = $("#" + target);
    
    submenu_list = fixMenuOrdering(submenu_list, target, {
        'id': target,
        'text': $(this).html()
    });
    if (isMobile) {
        menuClasses[first_column_id].jq_element.fadeOut(200, function() {
            menuClasses[first_column_id].resetMenuSettings();
        });
        
        setTimeout(function() {
            // Reset the target menus first before applying styling
            menuClasses[second_column_menu.attr('id')].resetMenuSettings();
            menuClasses[second_column_menu.attr('id')].jq_element.removeClass('hidden').addClass('first-column');
            menuClasses[second_column_menu.attr('id')].menuItem().removeAttr('style');
            menuClasses[second_column_menu.attr('id')].menuItem().children('a').removeClass('blur-link').addClass('active-link');
            menuClasses[second_column_menu.attr('id')].animate('in-from-left');
            
        }, 230);
        
        buildMobileBreadCrumb(target);
        return;
    }
    
    menuClasses[first_column_id].jq_element.fadeOut(200, function() {
        menuClasses[first_column_id].resetMenuSettings();
    });
    
    menuClasses[second_column_id].jq_element.fadeOut(200, function() {
        // Reset previous menu to hide
        menuClasses[second_column_id].resetMenuSettings();
    });
    
    if (target == 0) {
        main_menu_container.removeClass("sub-menu--loaded");
        menuClasses[target].resetMenuSettings();
        setTimeout(function() {
            menuClasses[target].jq_element.removeClass('hidden').addClass('first-column');  
            menuClasses[target].menuItem().removeAttr('style');
            menuClasses[target].menuItem().children('a').removeClass('active-link').removeClass('blur-link');
            menuClasses[target].animate('in-from-right');
            
            buildBreadCrumb(target);
        }, 500);
        
        buildBreadCrumb(target);
        
        return;
    }
    
    setTimeout(function() {
        // Reset the target menus first before applying styling
        menuClasses[first_column_menu.attr('id')].resetMenuSettings();
        menuClasses[second_column_menu.attr('id')].resetMenuSettings();
        
        menuClasses[first_column_menu.attr('id')].jq_element.removeClass('hidden').addClass('first-column');
        menuClasses[second_column_menu.attr('id')].jq_element.removeClass('hidden').addClass('second-column');
        
        menuClasses[first_column_menu.attr('id')].menuItem().removeAttr('style');
        menuClasses[second_column_menu.attr('id')].menuItem().removeAttr('style');
        menuClasses[first_column_menu.attr('id')].menuItem().children('a').removeClass('active-link').addClass('blur-link');
        $("[data-id=" + target + "]").children('a').addClass('active-link').removeClass('blur-link');
        menuClasses[second_column_menu.attr('id')].menuItem().children('a').removeClass('active-link').removeClass('blur-link');
    
        menuClasses[first_column_menu.attr('id')].animate('in-from-left');
        menuClasses[second_column_menu.attr('id')].animate("in-from-right")
        
    }, 230);
    buildBreadCrumb(target);
  return false;
});

function fixMenuOrdering(submenu, key_search, newObject)
{
    var new_list = [];
    var id = key_search
    
    $.each(submenu, function(index) {
        
        if (this.id == id) {
            new_list.push(newObject);
            return false;
        }
        
        new_list.push({
            'id': this.id,
            'text': this.text
        })
    })
    
    return new_list;
}

function slideSecondColumn(target)
{
    // Check if the menu doesn't have a loaded second column
    if (!target.hasClass("second-column")) {
        target.addClass("second-column");
        
        setTimeout(function() {
            menuClasses[target.attr('id')].animate();    
        }, (menuClasses[target.attr('id')].menuItem().length * 100));
    }
}
function resetMenu()
{
    var homeText = "Home";

    if ($("#country_code").val() == "zh-cn")
    {
        homeText = "首页";
    } else if ($("#country_code").val() == "zh-tw")
    {
        homeText = "首頁";
    }
    $(".in-from-right").removeClass("in-from-right");
    $(".out-to-left").removeClass("out-to-left");
    $(".second-column").removeClass("second-column");
    $(".first-column").removeClass("first-column");
    $(".visible").removeClass("visible");
    $(".main--navigation .menu").addClass("hidden").removeAttr('style');
    $(".menu-item").css("opacity", 0).removeAttr("style");
    $(".menu--top-level").addClass("first-column").removeClass("hidden");
    
    $(".main--navigation").find('.blur-link').removeClass("blur-link");
    
    submenu_list = [];
    submenu_list.push({
        'id': 0,
        'text': homeText
    });
    bread_crumb.html("");
}
function animate(menu, class_animation)
{
    var list = menu.children("li");
    var num = 0;
    var total_num = (list.length * 100) + 400;
    
    list.each(function(index) {
        num += 100;
        var source = $(this);
        // console.log(400 + num);

        setTimeout(function() {
            source.addClass(class_animation)
            .css("opacity", 1);
            
            if (class_animation == "out-to-right") {
                source.removeClass("in-from-right");
            } else if(class_animation == "in-from-right") {
                source.removeClass("out-to-right");
            }
        
        }, 400 + num);      
      
    })
    
    return total_num;
}

function findSubmenu(menu, parent_key = "0", lvl = 0)
{
    var current_menu = menu;
    var menu_items = menu.children(".menu-item");
    var random_string = "";
    var level = lvl;
    
    if (parent_key) {
        menu.attr('id', parent_key);
    }
    level += 1;
    menu.attr('data-level', level);
    menu_items.each(function(index) {

      if ($(this).hasClass('menu-item--expanded')) {
           
          var submenu = $(this).children('.menu');
           
          if (submenu.length) {
                random_string = generator(base, 28);
                $(this).attr('data-id', random_string);
                submenu.addClass("hidden");
                findSubmenu(submenu, random_string, level);
                submenu.detach().appendTo($(".menu--top-level").parents('nav'));
                
          }
      } 
    });
}

function buildMobileBreadCrumb(target_id = "")
{
    var list_str = "";
    
    if (submenu_list.length <= 1) {
        bread_crumb.html(list_str);
        return;
    }
    $.each(submenu_list, function(index, value) {
        if (target_id === 0) {
            return false;
        }
        if (target_id !== "" && target_id == value.id) {
            list_str += "<li><a href='#' class='breadcrumb_link' data-target-id='" + value.id +"'>" + value.text +"</li>";
            return false;
        }
        
        list_str += "<li><a href='#' class='breadcrumb_link' data-target-id='" + value.id +"'>" + value.text +"</li>";
    });
    
    
    bread_crumb.html(list_str);
}
function buildBreadCrumb(target_id = "")
{
    var list_str = "";
    
    if (submenu_list.length <= 1) {
        bread_crumb.html(list_str);
        return;
    }
    
    $.each(submenu_list, function(index, value) {
        if (target_id === 0) {
            list_str = "";
            return false;
        }
        if (target_id !== "" && target_id == value.id) {
            list_str += "<li><a href='#' class='breadcrumb_link' data-target-id='" + value.id +"'>" + value.text +"</li>";    
            return false;
        }
        list_str += "<li><a href='#' class='breadcrumb_link' data-target-id='" + value.id +"'>" + value.text +"</li>";
    });

    bread_crumb.html(list_str);
}
